<template>
	<div class="contentPage trucksRoad">
		<div class="trucksRoadScroll">
			<div class="trucksRoadHeader">
				<div class="trucksRoadHeader_title">
					<span>Trucks on the road</span>
					<refresh-date-block
							v-if="datesColor"
							:fleetApproved="fleetApproved"
							:dispatcherApproved="dispatcherApproved"
							:datesColor="datesColor"
							:isDateFilter="getDateFilter"
							:dateFilter="dateFilter"
							@updateHardTrucks="onHardTrucks"
					></refresh-date-block>
				</div>
				<div class="trucksRoadHeader_top">
					<div class="search">
						<div class="search__wrap">
							<v-text-field
									v-model="search"
									label="Search"
									class="search__table"
									hide-details
									@keyup.enter="onSearch"
							></v-text-field>
							<span class="icoSvg"><svg-sprite icon-id="icon_search" width="14" height="14"></svg-sprite></span>
						</div>
					</div>
					<div class="rightBlock">
						<button
								:disabled="!getDateFilter"
								class="mainBtn mainBtn-text not-hover"
								@click="onSendInvoices(1)"
						>
							<span class="btnIco"><svg-sprite icon-id="icon_send" width="20" height="20"></svg-sprite></span>
							<span class="btnText">Send report</span>
						</button>
						<button
								class="mainBtn mainBtn-text not-hover iconHoverRotate"
								@click="onRefresh"
						>
							<span class="btnIco"><svg-sprite icon-id="refresh" width="20" height="20"></svg-sprite></span>
							<span class="btnText">Refresh filters</span>
						</button>
						<div class="upload" @click="onGenerateExport">
							<svg-sprite icon-id="upload" width="20" height="20"></svg-sprite>
							<span>Export</span>
						</div>
					</div>
				</div>
			</div>
			<trucks-road-table
					v-if="trucksRoadFilter && linksPermissions"
					:filter="trucksRoadFilter"
					:list-items="trucksRoadList"
					:permissions="permissions"
					:linksPermissions="linksPermissions"
					:isFilterList="isFilterList"
					:isRefreshDate="isRefreshDate"
					:isRefresh="refresh"
					:search="search"
					:isSearch="isSearch"
					:isGenerateExport="isGenerateExport"
					:isSendInvoices="isSendInvoices"
					:datesColor="datesColor"
					:dateFilter="dateFilter"
					:emailsFromSend="trucksOnTheRoad"
					@updateEdit="onEdit"
					@updateRemoveItem="getRemoveItem"
					@updateCleanSearch="onCleanSearch"
			></trucks-road-table>
		</div>
		<remove-block v-if="isRemove" @updateRemoveItem="onRemoveItem" @updateRemoveClose="onRemoveClose"></remove-block>
	</div>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import TrucksRoadTable from "@/components/Fleet/TrucksRoad/TrucksRoadTable/TrucksRoadTable";
import RefreshDateBlock from "@/components/Fleet/TrucksRoad/RefreshDateBlock/RefreshDateBlock";
import RemoveBlock from "@/shared/RemoveBlock/RemoveBlock";
// helpers
import getUniqId from "@/helper/getUniqId";

export default {
	name: "TrucksRoad",
	components: {
		TrucksRoadTable,
		RefreshDateBlock,
		RemoveBlock
	},
	computed: {
		...mapGetters([
			'trucksRoadFilter',
			'trucksRoadList',
			'permissions',
			'fleetApproved',
			'dispatcherApproved',
			'datesColor',
			'isRefreshDate',
			'isDateFilter',
			'dateFilter',
			'trucksOnTheRoad',
			'linksPermissions',
			'getTabPermission',
			'permissions'
		]),
		getDateFilter() {
			if (this.isDateFilter === null) return true;
			return this.isDateFilter;
		}
	},
	data: () => ({
		search: '',
		isSearch: false,
		isGenerateExport: null,
		selectValue: 1,
		isFilterList: null,
		isRemove: false,
		isSendInvoices: null,
		removeItem: null,
		refresh: '',
		linksPerm: [ 5, 3, 6 ],
	}),
	methods: {
		...mapActions([
			'onTrucksRoad',
			'onWorkOrderComments',
			'onTrucksRoadDelete',
			'onWorkOrdersPreloader',
			'onRefresh',
			'onLinksPermissions',
		]),
		onHardTrucks() {
			this.refresh = getUniqId();
		},
		onGenerateExport() {
			this.isGenerateExport = getUniqId();
		},
		onSearch() {
			this.isSearch = !this.isSearch;
		},
		onCleanSearch() {
			this.search = '';
		},
		onSendInvoices() {
			this.isSendInvoices = getUniqId();
		},
		onFilterList() {
			this.isFilterList = getUniqId();
		},
		onEdit(id) {
			this.currentId = id;
		},
		getRemoveItem(id) {
			this.removeItem = id;
			this.isRemove = true;
		},
		onRemoveClose() {
			this.isRemove = false;
		},
		async onRemoveItem() {
			await this.onTrucksRoadDelete(this.removeItem);
			this.isRemove = false;
		}
	},
	async mounted() {
		await this.onTrucksRoad();
		await this.onLinksPermissions(this.linksPerm);
	},
};
</script>

<style scoped lang="scss">
@import "trucksRoad";
</style>

<style lang="scss">
.rightBlock .theme--dark.v-input {
	margin-top: 0 !important;
}
</style>
